
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './app/store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Components/App/App';
import 'react-app-polyfill/stable'
import 'core-js'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import 'react-image-gallery/styles/css/image-gallery.css'
import { Loader } from './Components/Loader/Index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <Provider store={store}>
            <PersistGate
                loading={
                    <div className="text-center">
                        <h3 className="me-2">Cargando</h3>
                        <Loader />
                    </div>
                }
                persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </>
);

